import { render, staticRenderFns } from "./ContextRows.vue?vue&type=template&id=4a8835b3&scoped=true"
import script from "./ContextRows.vue?vue&type=script&lang=js"
export * from "./ContextRows.vue?vue&type=script&lang=js"
import style0 from "./ContextRows.vue?vue&type=style&index=0&id=4a8835b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8835b3",
  null
  
)

export default component.exports